// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--6-1!./swiper.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("483f317a", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/swiper.css
// module id = bERN
// module chunks = 1